import React from 'react';
import ReportFrame from '../ReportFrame';

export default class ShopCountReport extends React.Component {
  render() {
    return (
      <div className='contentwrapperiframe bg-white'>
        <iframe
          title='ShopCountReport'
          src='https://app.powerbi.com/view?r=eyJrIjoiODM3OTVjMjQtOGQ3NS00Y2NmLWEzNzItNzcwZmNmMzQwMTBhIiwidCI6IjE0NWE1Yjg1LTkzYWEtNDg2OC1hZmEwLWFkZWRjOTA0ZWM3YSIsImMiOjF9'
          className='report-frame'
          id='shopCountReport'
          name='shopcountreport'
          frameborder='0'
          allowFullScreen='true'
        />
      </div>
    );
  }
}
